import { useState } from 'react'
import { useAllUserList, useApartmentListForCourse, useTrainerAttendanceList } from '../../assets/api/useAdminApi'
import { Grid2, Typography } from '@mui/material'
import { Field } from 'formik'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import { DateFormField } from '../../shared/components/formfields/DataFormField'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { formatDateToDDMMYYYY } from '../../shared/formatter'
import { useApartmentOptions } from '../admin/option/ApartmentOption'


const ViewTrainerAttendance = () => {
    const [filters, setFilters] = useState({});
    const { data: allUserList, isLoading } = useAllUserList({ role: "trainer" ,})
    const { data: attendanceList, isLoading: isAttendaceLoading } = useTrainerAttendanceList(filters)
    const trainerOption = allUserList?.data?.map((item, index) => ({
        id: item?.id,
        value: item?.firstname,
        label: item?.firstname
    })) || [];
    // const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    // const ApartmentOptions = apartmentList?.data
    //     ?.filter((item) => item?.is_verified !== 1)
    //     .map((item) => ({
    //         id: item?.id,
    //         label: item?.apartment_name,
    //         value: item?.apartment_name,
    //     })) || [];

    const { courseApartmentOption } = useApartmentOptions()
    const attendanceColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "firstname",
            headerName: "Trainer Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "course_title",
            headerName: "Title",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "batch_name",
            headerName: "Batch Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "created_date",
            headerName: "Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{formatDateToDDMMYYYY(params.value)}</Typography>,
        },

        {
            field: "attendance_status",
            headerName: "Attendance Status",
            flex: 1,
            renderCell: (params) =>
                <Typography variant="body2" color={params.value === 1 ? "success.main" : "error.main"
                } > {params.value === 1 ? "Present" : "Absent"} </Typography >,
        },

    ];

    return (
        <>
            <TableFilterTemplate
                title="Trainer Attendance"
                columns={attendanceColumn}
                rowsData={attendanceList || []}
                isLoading={isAttendaceLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={({ values }) => (
                    <>
                        <Grid2 children size={12}>
                            <Field
                                name="trainer_id"
                                component={IdAutoCompleteField}
                                options={trainerOption}
                                label="Select Trainer"
                                isLoading={isLoading}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="apartment_id"
                                component={IdAutoCompleteField}
                                options={courseApartmentOption.options}
                                label="Select Apartment"
                                isLoading={courseApartmentOption.isLoading}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="start_date"
                                component={DateFormField}
                                label="Start Date"
                                maxDate={values.end_date || undefined}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="end_date"
                                component={DateFormField}
                                label="End Date"
                                minDate={values.start_date || undefined}

                            />
                        </Grid2>
                    </>
                )}
            />
        </>
    )
}

export default ViewTrainerAttendance